/**
 * Returns the next quantity for the cart minus action.
 * `null` means the line must be removed instead of retaining a zero quantity.
 */
export function decrementCartQuantity(quantity: number): number | null {
  return quantity <= 1 ? null : quantity - 1;
}
